export default "__VITE_ASSET__C3nh1yWJ__"